'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
var useDrag = require('../../../../hooks/use-drag.js');
var useDrop = require('../../../../hooks/use-drop.js');
require('../../../../utilities/color.js');
require('date-fns');
require('../../../../utilities/locale.js');
require('../../../../hooks/use-prevent-keyboard-scrolling.js');
var tr = require('../standard-table/tr.js');
var dndTableDragContext = require('./dnd-table-drag-context.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const DndTr = ({ children , className , format , moveRow , onDropped , rowId , setDragData , ...otherProps })=>{
    const ref = React.useRef(null);
    const dragContext = React.useContext(dndTableDragContext.DndTableDragContext);
    const data = React.useMemo(()=>({
            rowId
        }), [
        rowId
    ]);
    const [dropped, setDropped] = React.useState(false);
    const handleDragEnter = ()=>{
        if (dragging) {
            // We're on top of the element being dragged
            return;
        }
        if (data && dragContext.data && dragContext.data.rowId !== data.rowId) {
            // Over a different row, trigger move
            moveRow(dragContext.data.rowId, data.rowId);
        }
    };
    const handleDropped = (dragData, event, format)=>{
        setDropped(true);
        onDropped(event, format, dragData);
    };
    const handleDragEnd = (event)=>{
        // Emulate "drop" if event wasn't previously fired. As rows are moved around while dragging we want to treat this
        // as a drop even if it was released outside of the table.
        if (!dropped) {
            onDropped(event.nativeEvent, format, data);
        }
        setDropped(false);
    };
    useDrop.useDrop({
        format: format,
        onDropped: handleDropped,
        ref
    });
    const { dragging  } = useDrag.useDrag({
        format: format,
        data,
        ref
    });
    React.useEffect(()=>{
        setDragData(dragging ? data : undefined);
        // Changing the opacity is done here with a short delay so the bitmap copy of the element isn't invisible when
        // under the cursor
        setTimeout(()=>{
            if (ref.current) {
                ref.current.style.opacity = dragging ? '0' : '1';
            }
        }, 1);
    }, [
        data,
        dragging,
        setDragData
    ]);
    return /*#__PURE__*/ React__default.default.createElement(tr.Tr, _extends({}, otherProps, {
        ref: ref,
        className: classnames__default.default({
            'bf-table__dnd-tr': true,
            'bf-table__dnd-tr--dragging': dragging,
            [`${className}`]: !!className
        }),
        onDragEnter: handleDragEnter,
        onDragEnd: handleDragEnd,
        "data-row-id": rowId
    }), children);
};

exports.DndTr = DndTr;
//# sourceMappingURL=dnd-tr.js.map
